import { connect } from 'react-redux';
import ArtifactHitCountModalComponent from
  './../Components/ArtifactHitCountModalComponent.jsx';
import { owners } from './../helpers/modals';
import {
  caseMetricsPageReducer,
  getCaseMetricsScanMetrics,
  getModalInfoByOwner,
  getModalVisibility,
} from './../reducers';
import { modal as modalActions } from './../actions';
import { union, keys } from 'lodash';

export const mapStateToProps = (state) => {
  const artifactModalInfo = getModalInfoByOwner(state, owners.artifactHitCount);
  const selected = caseMetricsPageReducer.getCaseSelectedJobs(state);
  const metrics = getCaseMetricsScanMetrics(state);
  const type = artifactModalInfo.isCcf ? 'ccf' : 'ncf';

  const primary = selected[0] ? metrics[selected[0].index] : undefined;
  const baseline = selected[1] ? metrics[selected[1].index] : undefined;

  const primaryHitCounts = primary && primary[type] ? primary[type].countsByArtifact : {};
  const baselineHitCounts =
    baseline && baseline[type] ? baseline[type].countsByArtifact : {};
  const artifacts = union(keys(primaryHitCounts), keys(baselineHitCounts)).sort();

  return {
    visible: getModalVisibility(state, owners.artifactHitCount),
    title: type.toUpperCase() + ' Hit Changes',
    artifacts,
    baselineHitCounts,
    hitCounts: primaryHitCounts,
    scanKey: '',
    isExpectedBaseline: false,
    diffOnly: artifactModalInfo.diffOnly
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    setDiffOnly: diffOnly =>
      dispatch(modalActions.setArtifactHitCountModalDiffOnly(diffOnly)),
    onHide: () => dispatch(modalActions.showArtifactHitCountModal(false)),
    openConfirm: () => {}
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactHitCountModalComponent);


// WEBPACK FOOTER //
// src/Containers/CaseMetricsArtifactHitCountModalContainer.jsx